export default [
  {
    path: "/pengaduan/",
    component: () => import("@/pages/complaint/complaint-list.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
  {
    path: "/pengaduan/detail/:id",
    component: () => import("@/pages/complaint/complaint-detail.vue"),
    meta: {
      requiredLevel: "admin",
    },
  },
];
